import { useEffect } from 'react';

/**
 * Calls the given callback when the page is restored from bfcache (browser back-forward cache).
 * Use for OAuth flows: when user clicks "Back" after starting a redirect, the page may restore
 * with stale state (e.g. loading=true). This hook resets it so the user can try again.
 */
export function useResetOnBfcacheRestore(onRestore: () => void): void {
  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) onRestore();
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, [onRestore]);
}
